// Vector ("technical flat") garment illustrations for the design tool — replaces
// photo-based recolouring. Each garment can have multiple `views` (front/back/...),
// each with its own shapes and placement zone — same idea as photoViews in
// garments-data.js, just vector shapes instead of a photo filename.
//
// Per view: `recolorLayers` get filled with whatever colour the customer picks;
// `fixedLayers` (e.g. a trucker cap's mesh back) never change colour; `details` is
// static line art (stitching, seams, drawstrings) drawn with stroke/fill="currentColor"
// so it always stays legible — the tool sets the SVG's CSS `color` to a light or dark
// tone depending on how light the chosen garment colour is.
//
// `referenceImage` is a real product photo shown as a small thumbnail next to the
// illustration, purely so the customer can see what the actual fabric/material looks
// like — it is never itself recoloured.
//
// `zone` (per view) is the embroidery/print placement area, in percent of the viewBox.
window.GARMENTS_VECTOR = [
  
  
  
  
  
];
